import { render, staticRenderFns } from "./BotOnePlatformIndex.vue?vue&type=template&id=6dc2d2ce&scoped=true&"
import script from "./BotOnePlatformIndex.vue?vue&type=script&lang=js&"
export * from "./BotOnePlatformIndex.vue?vue&type=script&lang=js&"
import style0 from "./BotOnePlatformIndex.vue?vue&type=style&index=0&id=6dc2d2ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc2d2ce",
  null
  
)

export default component.exports